import { pathname } from "store/reducers/ActionCreators";
import notifyError from "utils/Notifications/Error";
import cookie from "js-cookie";
import Error from "utils/Notifications/Error";
import Success from "./Notifications/Success";

const errors = {
    no_con: "No WS connection was found",
    invalid_arg: "Invalid argument provided",
    closed_before_init: "WS closed before connection established",
};

enum SocketEvents {
    get_workspace = "get_workspace",
}

type MemoCallback = {
    event: WSEvent;
    callback: any;
};

export type SavedConnection = {
    name: string;
    connection: WebSocket;
    id: number | string;
};

type WSEvent = keyof typeof SocketEvents;

const _pathname = pathname.replace("https://", "").replace("http://", "");

const urls = {
    get_workspace: `ws://${_pathname}ws`,
};

const actions = {
    get_workspace: (args: any[]): string => {
        if (!args || !Array.isArray(args)) {
            WS.handleError(errors.invalid_arg);
        }
        const tab_name = args[0];
        return `${urls.get_workspace}/${tab_name}/`;
    },
};

class WS {
    _connection: WebSocket;
    callbacks: MemoCallback[] = [];
    _active_tab: string;
    robotError: string = "";
    SSE_connection: EventSource;
    saved_tabs: SavedConnection[] = [];

    constructor() {
        this.connect = this.connect.bind(this);
        this.listen = this.listen.bind(this);
        this._registerCallback = this._registerCallback.bind(this);
        this._unRegisterCallback = this._unRegisterCallback.bind(this);
        this.drop = this.drop.bind(this);
    }

    drop() {
        const states = [0, 1, 2];
        //const con = this.connection;
        const active_connections = this.saved_tabs.filter(
            (t) => t.connection && states.includes(t.connection.readyState)
        );

        for (const _connection of active_connections) {
            const connection = _connection.connection;
            if (connection) {
                console.log("connection.readystate", connection.readyState);
            }
            if (connection && states.includes(connection.readyState)) {
                try {
                    connection.close();
                    return;
                } catch (error) {
                    WS.handleError(errors.closed_before_init);
                }
            }
        }
    }

    addListeners(socket: WebSocket) {
        const listeners = [];
    }

    get connection(): WebSocket {
        const con = this._connection;
        if (!con) {
            //WS.handleError(errors.no_con);
        }
        return this._connection;
    }

    set connection(con: WebSocket) {
        this._connection = con;
    }

    async connect({
        tab_id,
        onUpdate,
        name,
    }: {
        tab_id: string;
        onUpdate: Function;
        name: string;
    }) {
        this.active_tab = tab_id;
        this.drop();

        const url = WS.createWSUrl({
            event: "get_workspace",
            args: [tab_id],
        });
        let ws;
        try {
            ws = new WebSocket(url);
        } catch (error) {
            WS.handleError(errors.no_con);
            return errors.no_con;
        }

        this.saved_tabs.push({
            name,
            id: tab_id,
            connection: ws,
        });

        ws.addEventListener("open", () => {
            const message = name
                ? `Соединение со вкладкой ${name} установлено`
                : "Соединение установлено";
            Success(message);
            ws.send(
                JSON.stringify({
                    message: "ok",
                })
            );
        });
        ws.addEventListener("message", onUpdate);

        ws.addEventListener("close", () => {
            // console.log("WS CLOSED");
            // const prev_tab = this.saved_tabs[this.saved_tabs.length - 2];
            // const message = prev_tab
            //     ? `Соединение со вкладкой ${prev_tab.name} прервано`
            //     : "Соединение прервано";
            // //nReconnect()
            // Success(message);
        });
        ws.onerror = WS.handleError;
        this.connection = ws;
    }

    async openCheckErrorsConnection() {
        if (this.SSE_connection) {
            console.log("SSE_connection already exists");
            return;
        }
        let es;
        try {
            const token = cookie.get("access");
            es = new EventSource(`${pathname}/events/?token=${token}`);
        } catch (error) {
            WS.handleError(errors.no_con);
            return errors.no_con;
        }

        this.SSE_connection = es;

        es.addEventListener("message", (message) => {
            const error = JSON.parse(message.data);
            // if (this.robotError === error) return;
            //const mess = JSON.parse(message);

            this.robotError = error;
            let displayed_error =
                typeof error === "object" && Array.isArray(error.errors)
                    ? error.errors[0]
                    : error;
            console.log(this.robotError);
            notifyError(`Произошла ошибка на роботе: ${displayed_error}`);
        });

        es.addEventListener("error", (e) => {
            notifyError("SSE connection closed");
        });

        es.addEventListener("close", () => {
            console.log("Close EventSource");
        });
    }

    listen(event: WSEvent, callback: any) {
        return this._registerCallback(event, callback);
    }

    _registerCallback(event: WSEvent, callback: any) {
        const con = this.connection;
        if (!con) {
            return;
        }
        con.onmessage = (event: any) => {
            console.log("event", event);
        };
        //con.addEventListener('message', callback);
        this.callbacks.push({
            event,
            callback,
        });
    }

    _unRegisterCallback(event: WSEvent) {
        const con = this.connection;
        const found_callback = this.callbacks.find((cb) => cb.event === event);
        if (found_callback && con) {
            con.removeEventListener("message", found_callback.callback);
            this.callbacks = this.callbacks.filter((cb) => cb.event !== event);
        }
    }

    static createWSUrl({ event, args }: { event: WSEvent; args: any[] }) {
        const token = cookie.get("access");
        const url = actions[event]([...args]);
        return `${url}?token=${token}`;
    }

    static handleError(error: string) {
        console.error("Received error", error);
    }

    get active_tab() {
        return this._active_tab;
    }
    set active_tab(tab: string) {
        this._active_tab = tab;
    }
}

export default new WS();
